<template>
  <SoAlert
    v-if="isError"
    type="error"
    title="Failed to load files summary"
    data-testid="warrants-files-summary-error"
  />
  <div
    v-else
    class="d-flex ga-4 flex-wrap"
    data-testid="warrants-files-summary-card"
  >
    <SoWidget style="flex: 1 1 0" data-testid="warrants-files-status-summary">
      <template #title>
        <h6 class="font-weight-medium">Files by status</h6>
      </template>
      <SoSummaryTable
        :items="statusItems"
        :loading="isLoading"
        :aria-headers="['Metric', 'Value']"
      />
    </SoWidget>
    <SoWidget style="flex: 1 1 0" data-testid="warrants-files-type-summary">
      <template #title>
        <h6 class="font-weight-medium">Files by type</h6>
      </template>
      <SoSummaryTable
        :items="typeItems"
        :loading="isLoading"
        :aria-headers="['Metric', 'Value']"
      />
    </SoWidget>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoWidget from "@/components/SoWidget.vue"
  import SoSummaryTable from "@/components/SoSummaryTable.vue"
  import SoAlert from "@/components/SoAlert.vue"
  import { SoSummaryTableItem } from "@/types/components/SoSummaryTable"
  import { QueryResult } from "@/api/utils/types"
  import { WarrantsFilesSummaryService } from "@/services/admin/WarrantsFilesSummaryService"
  import { IWarrantsFilesSummary } from "@/models/admin/warrantsFilesSummary/warrantsFilesSummary.types"

  const EMPTY_SUMMARY: IWarrantsFilesSummary = {
    status: { total: 0, pending: 0, success: 0, failed: 0 },
    types: { returns: 0, cancellation: 0 },
  }

  export default defineComponent({
    name: "WarrantsFilesSummaryCard",
    components: {
      SoWidget,
      SoSummaryTable,
      SoAlert,
    },
    data() {
      return {
        summaryQuery: null as QueryResult<IWarrantsFilesSummary> | null,
      }
    },
    computed: {
      isLoading(): boolean {
        return Boolean(this.summaryQuery?.isFetching)
      },
      isError(): boolean {
        return Boolean(this.summaryQuery?.isError)
      },
      summaryData(): IWarrantsFilesSummary {
        return this.summaryQuery?.data ?? EMPTY_SUMMARY
      },
      statusItems(): SoSummaryTableItem[] {
        const { total, pending, success, failed } = this.summaryData.status
        return [
          { title: "Total files", value: total },
          { title: "Pending", value: pending },
          { title: "Success", value: success },
          { title: "Failed", value: failed },
        ]
      },
      typeItems(): SoSummaryTableItem[] {
        const { returns, cancellation } = this.summaryData.types
        return [
          { title: "Returns", value: returns },
          { title: "Cancellation", value: cancellation },
        ]
      },
    },
    mounted() {
      this.summaryQuery = WarrantsFilesSummaryService.getSummary()
    },
  })
</script>
